module.exports = __webpack_public_path__ + "img/jeep-capture.3f19cf0b.svg";